import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AfDetailModule, AfRowItemModule } from "@pattonair/auction-framework";
import { MfDialogModule } from "@pattonair/material-framework";
import { AucWonListComponent } from "./won.list.component";

@NgModule({
  declarations: [
    AucWonListComponent,
  ],
  exports: [
    AucWonListComponent,
  ],
  imports: [
    BrowserModule,
    AfRowItemModule,
    AfDetailModule,
    MfDialogModule,
  ]
})
export class AucWonListModule { }